(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/client-gamecache/assets/javascripts/client-gamecache.js') >= 0) return;  svs.modules.push('/components/casino-react/client-gamecache/assets/javascripts/client-gamecache.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const formatGame = svs.components.casino.formatGame.formatGame;
class ClientGamecache {
  constructor() {
    this.games = {}; 

    let bakeNum = 0;
    while ((_svs = svs) !== null && _svs !== void 0 && (_svs = _svs.casino_react) !== null && _svs !== void 0 && (_svs = _svs.clientGameCache) !== null && _svs !== void 0 && (_svs = _svs.data) !== null && _svs !== void 0 && _svs["initialGames_".concat(bakeNum)]) {
      var _svs;
      this.games = _objectSpread(_objectSpread({}, this.games), svs.casino_react.clientGameCache.data["initialGames_".concat(bakeNum)]);
      bakeNum++;
    }
  }
  static getClientGamecache() {
    if (!_instance._) {
      _instance._ = new ClientGamecache();
    }
    return _instance._;
  }

  addToCache(newCMSGames) {
    newCMSGames.forEach(cmsGame => {
      this.games[cmsGame.name] = formatGame(cmsGame);
    });
  }

  getGameByOpsId(opsId) {
    return Object.values(this.games).find(game => game.opsGameId === opsId || game.opsGameIdMobile === opsId);
  }
  async populateByOpsIds(opsIds) {
    if (!opsIds || !Array.isArray(opsIds) || opsIds.length === 0) {
      return;
    }
    const res = await new Promise((resolve, reject) => {
      svs.content.shared.cms.basicFilter({
        type: 'cnt:casinoGame',
        propertyQuery: opsIds.map(id => "opsGameId=".concat(id, ",opsGameIdMobile=").concat(id)).join(','),
        count: 25
      }, (err, data) => {
        if (err) {
          reject();
        } else {
          resolve(data.result);
        }
      });
    });
    this.addToCache(res);
  }
}
var _instance = {
  _: void 0
};
setGlobal('svs.components.casino_react.ClientGamecache', ClientGamecache);

 })(window);